import React from 'react';

interface FormStepProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
  onNext?: () => void;
  onBack?: () => void;
  nextLabel?: string;
  showBack?: boolean;
  isLastStep?: boolean;
  isSubmitting?: boolean;
  error?: string;
}

export default function FormStep({
  children,
  title,
  subtitle,
  onNext,
  onBack,
  nextLabel = 'Continue',
  showBack = false,
  isLastStep = false,
  isSubmitting = false,
  error
}: FormStepProps) {
  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-pure-white rounded-md shadow-card p-8">
        <div className="text-center mb-8">
          <h1 className="text-title-lg text-gray-900 mb-2 font-inter">{title}</h1>
          {subtitle && (
            <p className="text-body-lg text-text-secondary">{subtitle}</p>
          )}
        </div>

        <div className="mb-8">{children}</div>

        {error && (
          <div className="bg-red-50 text-red-600 p-3 rounded-md mb-4">
            {error}
          </div>
        )}

        <div className="flex gap-3">
          {showBack && (
            <button
              type="button"
              onClick={onBack}
              className="flex-1 bg-gray-200 text-gray-700 py-3 px-4 rounded-md text-button hover:bg-gray-300 transition-colors duration-200 font-inter"
            >
              Back
            </button>
          )}
          <button
            type="button"
            onClick={onNext}
            disabled={isSubmitting}
            className="flex-1 bg-trust-blue text-pure-white py-3 px-4 rounded-md text-button hover:bg-trust-blue/90 focus:ring-2 focus:ring-trust-blue/20 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 shadow-button hover:shadow-button-hover font-inter"
          >
            {isSubmitting ? 'Submitting...' : isLastStep ? 'Submit' : nextLabel}
          </button>
        </div>
      </div>
    </div>
  );
}